module.exports = __webpack_public_path__ + "img/ubuntu-v14-latin-regular.f00252d.svg";